import { toast } from "react-hot-toast";

type NotifyMessage = string;

const NotificationService = {
  success(message: NotifyMessage) {
    toast.success(message);
  },
  error(message: NotifyMessage) {
    toast.error(message);
  },
  info(message: NotifyMessage) {
    toast(message);
  },
  warning(message: NotifyMessage) {
    toast(message, {
      icon: "⚠️",
    });
  },
};

export default NotificationService;
